/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import rgba from "assets/theme/functions/rgba";

import { Link } from "react-router-dom";
import { getHealthStatus } from "utils/device";
import SoftTypography from "components/SoftComponents/SoftTypography";

const BATTERY_THRESHOLD = 25;

function RevisedTableBodyCell({ noBorder = false, align = "left", weight = "normal", showAdvancedDeviceLevel, onRowClicked, children }) {

  const { light } = colors;
  const { size, fontFamily } = typography;
  const { borderWidth } = borders;
  const device = children.props.row.original;

  var priority_colour = rgba("#FFFFFF", 1);

  if (!device.active && showAdvancedDeviceLevel) {
    priority_colour = `linear-gradient(${rgba("#FFFFFF", 0.1)}, ${rgba("#555555", 0.2)})`;
  }
  else {
    if (device.connected_state == 'offline') {
      priority_colour = `linear-gradient(${rgba("#FFFFFF", 0.1)}, ${rgba("#FF0000", 0.1)})`;
    }
    else if (device.battery <= BATTERY_THRESHOLD && showAdvancedDeviceLevel) {
      priority_colour = `linear-gradient(${rgba("#FFFFFF", 0.1)}, ${rgba("#EDAA00", 0.2)})`;
    }
  }

  return (
    <SoftBox
      component="td"
      textAlign={align}
      fontSize={size.sm}
      borderBottom={noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`}
      sx={{ backgroundImage: priority_colour }}
    >
      {onRowClicked ? (
        <Link to={`../../devices/${device.uuid}`} style={{ textDecoration: 'none', padding: '12px 24px', display: 'flex', justifyContent: align }}>
          <SoftBox
            display="inline-block"
            width="max-content"
            sx={{ verticalAlign: "middle" }}
          >
            <SoftTypography variant={weight === "normal" ? "body5" : "button"} sx={{ fontWeight: weight }} color="dark">
              {children}
            </SoftTypography>
          </SoftBox>
        </Link>
      ) : (
        <SoftBox sx={{ textDecoration: 'none', padding: '12px 24px', display: 'flex', justifyContent: align }}>
          <SoftBox
            display="inline-block"
            width="max-content"
            sx={{ verticalAlign: "middle" }}
          >
            <SoftTypography variant={weight === "normal" ? "body5" : "button"} sx={{ fontWeight: weight }} color="dark">
              {children}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      )}
    </SoftBox>
  );
}

// Typechecking props for the RevisedTableBodyCell
RevisedTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  weight: PropTypes.oneOf(["normal", "light", "medium", "bold"]),
  showAdvancedDeviceLevel: PropTypes.bool,
  onRowClicked: PropTypes.func
};

export default RevisedTableBodyCell;
